// 货币名称 — 从运行时配置读取，支持不同环境显示不同名称
// jm 环境: 点券 / 喵币    tws 环境: 探玩币 / 探玩石
export const BALANCE_LABEL = (window as any).__CONFIG__?.BALANCE_LABEL || '探玩币'
export const POINT_LABEL = (window as any).__CONFIG__?.POINT_LABEL || '探玩石'
